export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';
export const detailsPage = {
  summarySection: {
    title: 'Transaction Summary',
  },
  eventLogSection: {
    title: 'State Changes',
  },
  paymentEventsSection: {
    title: 'Payment Events',
  },
  paymentInfoSection: {
    title: 'Payment Info',
  },
  itemsSection: {
    title: 'Items Purchased',
  },
};
